import React from 'react';
import api from '../assets/icons/api.svg'
import backend from '../assets/icons/backend.svg'
import algo from '../assets/icons/algo.svg'
import computer from '../assets/icons/computer.svg'
import repair from '../assets/icons/repair.svg'
import puzzle from '../assets/icons/puzzle.svg'

import Skillcard from './Skillcard';

const skills = [
    {
        icon: computer,
        title: "Front End Development",
        about: "Design and Layout of a website"
    },
    {
        icon: repair,
        title: "Back End Development",
        about: "Develop technical and maintain databases, data and application integration, API and other back end processes",
    },
    {
        icon: api,
        title: "API Development",
        about: "Develop REST API"
    },
    {
        icon: algo,
        title: "Competitive Coder",
        about: "The ability to work under intense pressure and solve complex problems"
    },
    {
        icon: puzzle,
        title: "UI/UX designer",
        about: "Creating wireframes, prototypes and implementing complex UIs"
    },
    {
        icon: computer,
        title: "Leading projects",
        about: "The ability to delegate responsibilities and deliver business outcomes as a team."
    },
]


const About = () => {
    return (
        <div className="about">
            <h6 className="about__intro">
            The ability to work under intense pressure and multi-task to meet deadlines or complete critical tasks.
            </h6>
            <div className="container about__container">
                <h6 className="about__heading">What I offer</h6>
                <div className="row">
                    {
                        skills.map(skill =>
                            <Skillcard skill={skill} />

                        )
                    }
                </div>
            </div>
        </div>
    );
};

export default About;